import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=27657f3a&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=27657f3a&prod&lang=less&scoped=true"
import style1 from "./productList.vue?vue&type=style&index=1&id=27657f3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27657f3a",
  null
  
)

export default component.exports